<template>
  <v-app>
  <div id="user">
    <span v-if="this.admin">
    <v-container fluid grid-list-md>
      <v-layout justify-center row wrap>
      <!-- 1st Row -->
        <v-flex xs12 md6>
          <v-card color="white" class="elevation-12">
            <v-card-title class="subheading">User Permissions:</v-card-title>
            <v-data-table
              :headers="headers"
              :items="users"
              expand
              :rows-per-page-items="[5, 10]"
              >
              <template slot="items" slot-scope="props">
                <tr @click="dialog = true" >
                  <td class="text-xs-center">{{ props.item.user }}</td>
                  <td class="text-xs-center">
                    <p v-if="props.item.admin"><v-icon  color="green">done</v-icon></p>
                    <p v-else><v-icon  color="red">close</v-icon></p>
                  </td>
                  <td class="text-xs-center">
                    <p v-if="props.item.standard"><v-icon  color="green">done</v-icon></p>
                    <p v-else><v-icon  color="red">close</v-icon></p>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-flex xs12 md3>
        <v-card color="white" class="elevation-12">
          <v-card-title class="subheading">Company List:</v-card-title>
          <v-data-table
            :headers="companyHeaders"
            :items="companies"
            expand
            :rows-per-page-items="[5, 10]"
            >
            <template slot="items" slot-scope="props">
              <tr @click="dialog = true" >
                <td class="text-xs-center">{{ props.item.company }}</td>
              </tr>
            </template>
          </v-data-table>
        <template v-if="this.admin">
        </template>
        <template v-else></template>
        </v-card>

      </v-flex>

      <v-flex xs12 md3>
        <v-card color="white" class="elevation-12">
          <v-card-title class="subheading">Device List:</v-card-title>
          <v-data-table
            :headers="deviceHeaders"
            :items="devices"
            expand
            :rows-per-page-items="[5, 10]"
            >
            <template slot="items" slot-scope="props">
              <tr @click="dialog = true" >
                <td class="text-xs-center">{{ props.item.devicetype }}</td>
              </tr>
            </template>
          </v-data-table>
        <template v-if="this.admin">
        </template>
        <template v-else></template>
        </v-card>
      </v-flex>

      <v-flex color="transparent" xs12 md3 >
        <v-btn block dark color="blue" to="/register">Register A New User</v-btn>
      </v-flex>
      <v-flex color="transparent" xs12 md3 >
        <v-btn block dark color="blue" to="/password">Change Your Password</v-btn>
      </v-flex>
      <v-flex color="transparent" xs12 md3 >
        <v-btn block dark color="blue" to="/addcompany">Add Company</v-btn>
      </v-flex>
      <v-flex color="transparent" xs12 md3 >
        <v-btn block dark color="blue" to="/adddevice">Add Device</v-btn>
      </v-flex>
      </v-layout>
      <v-flex color="transparent" xs12 md3>
        <v-btn block dark color="blue" to="/twilio">Twilio</v-btn>
      </v-flex>
    </v-container>
    </span>
    <span v-else>
      <v-container fluid grid-list-md>
      <v-layout justify-center row wrap>
      <!-- 1st Row -->
        <v-toolbar dark color="green lighten-1" class="elevation-12">
          <v-toolbar-title class="text-capitalize">
            {{currentUser.substr(0, currentUser.indexOf('@'))}}'s Dashboard:
          </v-toolbar-title>
        </v-toolbar>
        </v-layout>
        </v-container>

    </span>
  </div>
 </v-app>
</template>

<script>
import db from "./firebaseinit";
import firebase from 'firebase';
export default {
  name: 'user',
  data() {
    return {
      headers: [
        { text: "User", align: "center", sortable: true, value: "user" },
        { text: "Admin", align: "center", sortable: true, value: "admin" },
        { text: "Standard", align: "center", sortable: true, value: "standard" }
      ],
      companyHeaders: [
        { text: "Company Name", align: "center", sortable: true, value: "company" }
      ],
      deviceHeaders: [
        { text: "Device Type", align: "center", sortable: true, value: "devicetype" }
      ],
      isLoggedIn: false,
      companies: [],
      devices: [],
      users: [],
      currentUser: false,
      admin: false,
      standard: false,
      permissions: null,
      email: '',
      password: '',
      newpassword: '',
      passwordalert: false
    }
  },
  created () {
    if(firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      //Gets User Group//
      console.log(this.currentUser)
      console.log(this.users)
      var user = this.currentUser
      var a = this.users.indexOf(user)
      console.log(a)
      };
      db.collection("companies")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company
          };
          this.companies.push(data);
        });
      });
      db.collection("devices")
      .orderBy("devicetype")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'devicetype': doc.data().devicetype
          };
          this.devices.push(data);
        });
      });
      var users = db.collection("users")
      .orderBy("user")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'user': doc.data().user,
            'admin': doc.data().admin,
            'standard': doc.data().standard
          };
          this.users.push(data);
        });
      });

     var query = firebase.firestore().collection('users')
      .where("user", '==', this.currentUser)
      .get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
        console.log(doc.data())
        this.admin = doc.data().admin
        this.standard = doc.data().standard
        this.permissions = true
        })
        console.log("Admin: " + this.admin)
        console.log("Standard: " + this.standard)
        console.log(this.currentUser)
      })

  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue